module.exports = __webpack_public_path__ + "img/line_logo.60b4b154.png";